import moment from "moment";
export function parseDate(d) {
    return moment(d).local().toDate();
}
export function formatDateHuman(d) {
    return moment(d).format('DD/MM/YYYY');
}
export function formatTimestampHuman(d) {
    return moment(d).format('DD/MM/YYYY HH:mm');
}
export function formatCurrency(val) {
    return '€ ' + (val || 0).toFixed(2);
}
